import { Button } from '@/components';
import type { BatchModel } from '@/features/batch/_models/batch';
import { BulkExportPdfModel } from '@/features/mold/models/bulk-export-pdf';
import { downloadURL } from '@/utils/file-controller';
import classNames from 'classnames';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import styles from './PdfPrint.module.scss';

const _printHiddenClass = classNames(styles.print_only);

type Props = {
  batch: z.infer<typeof BatchModel>;
  isLoading: boolean;
  jsonData: any;
};

export const DownloadByURLFile: FC<Props> = ({
  batch,
  jsonData,
  isLoading,
}) => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);
  const parsedJsonData = BulkExportPdfModel.safeParse(jsonData);

  if (!parsedJsonData.success || isLoading || batch.status !== 'success') {
    return null;
  }

  return (
    <Button
      type="primary"
      onClick={async () => {
        try {
          setIsDownloading(true);
          await downloadURL(
            parsedJsonData.data.url,
            parsedJsonData.data.fileName,
          );
        } finally {
          setIsDownloading(false);
        }
      }}
      loading={isDownloading}
    >
      {t('export-file')}
    </Button>
  );
};
